import React, { Fragment } from 'react'

import { If, Unless } from 'src/Components'
import EditBalanceInterstital from './EditBalanceInterstitial'
import EditBalanceForm from './EditBalanceForm'

const EditBalance = ({ shouldShowInterstitial, hideInterstitial }) => (
  <Fragment>
    <If condition={shouldShowInterstitial}>
      <EditBalanceInterstital hideInterstitial={hideInterstitial} />
    </If>
    <Unless condition={shouldShowInterstitial}>
      <EditBalanceForm />
    </Unless>
  </Fragment>
)

export default EditBalance
